module.exports = __webpack_public_path__ + "fonts/Nimbus-Sans-D-OT-Light-Extended_32750.8c4f5e7.ttf";